import Vue from "vue"
import Vuex from "vuex"
import trainMange from "./trainMange/index"
import trainUse from "./trainUse/index"

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const trainState = createPersistedState({
  paths: ["trainMange.facultyData","trainUse.stuCourseData"],
})

export default new Vuex.Store({
  modules: {
    trainMange,
    trainUse
  },
  plugins: [trainState],
})
